<template>
  <el-dialog title="选择商品" :visible.sync="dialogVisible" width="70%" :before-close="handleClose">

    <!-- 这里放置商品选择组件的内容 -->
    <div class="product-select-container">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="product-category">
            <!-- 商品分类树 -->
            <el-tree 
              :data="categoryData" 
              :props="defaultProps" 
              @node-click="handleNodeClick"
              highlight-current
              default-expand-all>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="16">
          <!-- 搜索条件 -->
          <div class="search-container" style="margin-bottom: 15px;">
            <el-form :inline="true" :model="searchForm">
              <el-form-item label="商品名称">
                <el-input 
                  v-model="searchForm.prodNameLike" 
                  placeholder="请输入商品名称"
                  clearable
                  @keyup.enter.native="queryProducts"
                  style="width: 200px;">
                </el-input>
              </el-form-item>
              <el-form-item label="条码">
                <el-input 
                  v-model="searchForm.barCode" 
                  placeholder="请输入条码"
                  clearable
                  @keyup.enter.native="queryProducts"
                  style="width: 200px;">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="queryProducts">查询</el-button>
                <el-button @click="resetSearch">重置</el-button>
              </el-form-item>
            </el-form>
          </div>

          <div class="product-list">
            <!-- 商品列表 -->
            <el-table 
              :data="productList" 
              border 
              style="width: 100%" 
              @selection-change="handleSelectionChange"
              v-loading="loading">
              <el-table-column type="selection" width="55">
              </el-table-column>
              <el-table-column prop="productId" label="商品编号" align="center" width="120">
              </el-table-column>
              <el-table-column prop="prodName" label="商品名称" align="center">
              </el-table-column>
              <el-table-column label="规格" align="center" width="150">
                <template slot-scope="scope">
                  {{ scope.row.defaultSpecValue ? scope.row.defaultSpecValue.specName : '-' }}
                </template>
              </el-table-column>
              <el-table-column label="库存" align="center" width="100">
                <template slot-scope="scope">
                  {{ scope.row.defaultSpecValue ? scope.row.defaultSpecValue.stock : '-' }}
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pagination.page"
              :page-size="pagination.row"
              layout="total, prev, pager, next"
              :total="pagination.total"
              style="margin-top: 15px; text-align: right;">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmSelection">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryProductCategory } from '@/api/goods/productCategoryApi'
import { queryProduct } from '@/api/goods/productApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ChooseProductAndSpec',
  data() {
    return {
      dialogVisible: false,
      categoryData: [],
      productList: [],
      selectedProducts: [],
      loading: false,
      defaultProps: {
        children: 'children',
        label: 'categoryName'
      },
      searchForm: {
        prodNameLike: '',
        barCode: '',
        categoryId: ''
      },
      pagination: {
        page: 1,
        row: 10,
        total: 0
      },
      shopId: '',
      shId: ''
    }
  },
  methods: {
    async open(param) {
      this.dialogVisible = true
      this._refreshChooseProductInfo()
      
      // 如果传入的是对象，取shId属性；如果直接传入shId，则使用传入的值
      if (param && typeof param === 'object' && param.shId) {
        this.shId = param.shId
      } else if (param) {
        this.shId = param
      }
      
      // 获取shopId
      this.shopId = getShopId()
      
      // 加载商品分类和商品列表
      await this._listChooseProductCategorys()
      await this._loadAllProductInfo(1, 10)
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {
          // 取消关闭
        })
    },
    _refreshChooseProductInfo() {
      this.searchForm = {
        prodNameLike: '',
        barCode: '',
        categoryId: ''
      }
      this.selectedProducts = []
      this.productList = []
      this.pagination = {
        page: 1,
        row: 10,
        total: 0
      }
      this.shId = ''
    },
    async _listChooseProductCategorys() {
      try {
        const params = {
          page: 1,
          row: 50,
          shopId: this.shopId
        }
        const res = await queryProductCategory(params)
        
        // 将分类列表转换为树形结构
        // 如果有parentCategoryId字段，可以构建树形结构
        // 这里先简单处理，将所有分类作为一级节点
        this.categoryData = this.buildCategoryTree(res.data || [])
      } catch (error) {
        console.error('获取商品分类失败:', error)
        this.$message.error('获取商品分类失败')
      }
    },
    // 构建分类树
    buildCategoryTree(categories) {
      if (!categories || categories.length === 0) {
        return []
      }
      
      // 添加一个"全部"根节点，所有分类作为子节点
      return [
        {
          categoryId: '',
          categoryName: '全部',
          children: categories.map(cat => ({
            ...cat,
            children: []
          }))
        }
      ]
    },
    handleNodeClick(data) {
      // 处理分类节点点击事件，加载对应分类的商品
      this.searchForm.categoryId = data.categoryId || ''
      this.pagination.page = 1
      this._loadAllProductInfo(1, this.pagination.row)
    },
    async _loadAllProductInfo(page, row) {
      this.loading = true
      try {
        const params = {
          page: page,
          row: row,
          shopId: this.shopId,
          shId: this.shId,
          prodNameLike: this.searchForm.prodNameLike,
          barCode: this.searchForm.barCode,
          categoryId: this.searchForm.categoryId
        }
        const res = await queryProduct(params)
        this.productList = res.data || []
        this.pagination.total = res.total || 0
        this.pagination.page = page
      } catch (error) {
        console.error('获取商品列表失败:', error)
        this.$message.error('获取商品列表失败')
      } finally {
        this.loading = false
      }
    },
    queryProducts() {
      this.pagination.page = 1
      this._loadAllProductInfo(1, this.pagination.row)
    },
    resetSearch() {
      this.searchForm.prodNameLike = ''
      this.searchForm.barCode = ''
      this.searchForm.categoryId = ''
      this.pagination.page = 1
      this._loadAllProductInfo(1, this.pagination.row)
    },
    handleCurrentChange(page) {
      this._loadAllProductInfo(page, this.pagination.row)
    },
    handleSelectionChange(val) {
      this.selectedProducts = val
    },
    confirmSelection() {
      if (this.selectedProducts.length === 0) {
        this.$message.warning('请至少选择一件商品')
        return
      }

      // 触发父组件事件
      this.$emit('chooseProductAndSpec', this.selectedProducts)
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
.product-select-container {
  padding: 10px;
}

.product-category {
  border: 1px solid #ebeef5;
  padding: 10px;
  height: 500px;
  overflow-y: auto;
}

.product-list {
  min-height: 400px;
}

.search-container {
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
}
</style>